import styled from "styled-components";

export const TabContainer = styled.div`
  display: flex;
  width: 100%;
  margin:auto;
  color: #101e8e;
  justify-content: center;
  flex-direction: column;
`;
export const CardsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  gap: 1rem;
  background: #fff;
  padding: 2rem;
  align-self: center;
`;

export const ServiceCard = styled.div`
  background-color:#E5EFF2;
  width: 100%;
  font-size: .9rem;
  font-weight: 700;
  display: flex;
  padding: 0.6rem;
  justify-content: space-between;
  align-items: center;
  color: #101e8e;
  .icon {
    display: flex;
    align-items: center;
    svg {
      color: #62aa51;
    }
  }
`;

export const CardsSectionContainer = styled.section`
  display: flex;
  width: 30%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export const SectionTitle = styled.div`
  border-bottom: 3px solid #101e8e;
  padding-bottom: 0.5rem;
  display: flex;
  justify-content: start;
  padding-left: 1rem;
  align-items: center;
  width: 100%;
  gap: 0.5rem;
`;
